const onTrasitionEnd = (element: HTMLElement | undefined | null, callback: () => void): void => {
    if (!element) return
    const handleTransitionEnd = (ev: TransitionEvent): void => {
        if (ev.target === element) {
            element.removeEventListener('transitionend', handleTransitionEnd)
        }
        callback()
    }
    element.addEventListener('transitionend', handleTransitionEnd)
}

export { onTrasitionEnd }
